module.exports = __webpack_public_path__ + "static/media/image2.9a39a8f7.jpg";